<script setup>
import {ref, onMounted, computed} from "vue";

const footerData = ref([]);

const currentYear = computed(() => {
  return new Date().getFullYear();
});
const props = defineProps({
  linkFacebook: {
    type: Array,
    default: () => []
  },
  linkInstagram: {
    type: Array,
    default: () => []
  }
});

const devByText = computed(() => 'powered by');

const fetchFooterData = async () => {
  try {
    const response = await fetch("/api/getfooter");
    footerData.value = await response.json();
  } catch (error) {
    console.error("Erro ao buscar dados do footer:", error);
  }
};

onMounted(() => {
  fetchFooterData();
});
</script>

<template>
  <footer class="basic-footer-content">
    <div class="container-footer">
      <div class="container-logo">
        <div class="logo">
          <a href="/">
            <svg xmlns="http://www.w3.org/2000/svg" width="137" height="55" viewBox="0 0 137 55" fill="none">
              <path d="M83.9111 20.499L76.8068 36.8174L78.5414 40.8884C79.3361 40.4635 79.9443 39.7919 80.3797
              38.8049L88.3755 20.499H83.9111Z" fill="white"/>
              <path d="M75.2104 37.537C74.934 37.4479 74.7336 37.2766 74.623 36.9819L67.726 20.499H63.3376L70.9395
              38.8049C71.7205 40.7102 73.2547 41.4847 75.6458 41.4847C76.0812 41.4847 76.4889 41.4573 76.869
              41.4025L75.2173 37.5233L75.2104 37.537Z" fill="white"/>
              <path d="M93.6277 20.4991V15.6399H97.8225V20.4991H103.545V24.4673H97.8225V34.1857C97.8225 36.4816
              98.6449 37.2561 100.601 37.2561H103.462V41.0256H99.7368C95.466 41.0256 93.6208 39.3122 93.6208
              33.9527V24.4673H90.8011V20.4991H93.6208H93.6277Z" fill="white"/>
              <path d="M52.7917 20.499H48.4448C42.9161 20.499 39.4677 23.8436 39.4677 30.7588C39.4677 37.6741
              42.9161 41.0186 48.4448 41.0186H52.7917C58.2789 41.0186 61.7689 37.6741 61.7689 30.7588C61.7689
              23.8436 58.2789 20.499 52.7917 20.499ZM52.3978 37.023H48.8318C45.2244 37.023 43.6556 35.1931 43.6556
              30.7657C43.6556 26.3383 45.2244 24.4672 48.8318 24.4672H52.3978C55.9638 24.4672 57.574 26.3314 57.574
              30.7657C57.574 35.2 55.9707 37.023 52.3978 37.023Z" fill="white"/>
              <path d="M24.1809 20.499C31.1954 20.499 34.6439 23.8024 34.6439 29.4772V41.0186H30.4491V29.4772C30.4491
              26.2492 28.5693 24.4672 24.2155 24.4672H19.3572V41.0255H15.1623V24.4672H4.6648C4.31235 24.4672 4.1534
              24.6591 4.1534 25.0498V40.8884H0V23.6859C0 21.2735 0.822387 20.499 2.90254 20.499H24.1879H24.1809Z"
                    fill="white"/>
              <path d="M80.4834 15.2012C85.4799 11.2193 91.6582 8.86168 98.334 8.86168C105.01 8.86168 111.181 11.2193
               116.185 15.2012H128.037C121.008 5.92835 110.317 0 98.334 0C86.3507 0 75.6596 5.92835 68.6313
               15.2012H80.4834Z" fill="#EE7623"/>
              <path d="M120.255 37.0231L121.962 41.0256H127.021V37.0231H120.255Z" fill="#A7CB47"/>
              <mask id="mask0_115_282" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="120" y="37" width="8" height="5">
                <path d="M120.255 37.0231L121.962 41.0256H127.021V37.0231H120.255Z" fill="white"/>
              </mask>
              <g mask="url(#mask0_115_282)">
                <path d="M121.948 34.1079L118.507 40.0195L125.33 43.9261L128.771 38.0144L121.948 34.1079Z"
                      fill="#A7CB47"/>
              </g>
              <path d="M111.188 27.3046C111.188 25.7077 112.087 24.4672 114.36 24.4672H121.022C123.061 24.4672
              123.959 25.4747 123.959 27.0305C123.959 28.5862 123.137 29.4772 120.905
              29.4772H111.188V27.2978V27.3046ZM114.36 20.499C109.184 20.499 107.152 23.3775 107.152
              27.2635V34.261C107.152 38.147 109.191 41.0255 114.36 41.0255H120.055L118.348 37.023H114.36C112.087
              37.023 111.188 35.8168 111.188 34.1856V32.7053H121.022C126.115 32.7053 128.037 30.5669 128.037
              26.7975C128.037 22.8361 125.957 20.499 121.064 20.499H114.36Z" fill="#A7CB47"/>
              <mask id="mask1_115_282" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="107" y="20" width="22" height="22">
                <path d="M111.188 27.3046C111.188 25.7077 112.087 24.4672 114.36 24.4672H121.022C123.061 24.4672
                123.959 25.4747 123.959 27.0305C123.959 28.5862 123.137 29.4772 120.905
                29.4772H111.188V27.2978V27.3046ZM114.36 20.499C109.184 20.499 107.152 23.3775 107.152
                27.2635V34.261C107.152 38.147 109.191 41.0255 114.36 41.0255H120.055L118.348 37.023H114.36C112.087
                37.023 111.188 35.8168 111.188 34.1856V32.7053H121.022C126.115 32.7053 128.037 30.5669 128.037
                26.7975C128.037 22.8361 125.957 20.499 121.064 20.499H114.36Z" fill="white"/>
              </mask>
              <g mask="url(#mask1_115_282)">
                <path d="M112.372 11.5354L98.191 35.8942L122.819 49.9954L137 25.6366L112.372 11.5354Z" fill="#A7CB47"/>
              </g>
              <path d="M124.72 46.762C124.92 46.7209 125.169 46.6934 125.459 46.666C125.749 46.6386 125.998 46.6386
              126.226 46.6386C126.516 46.6386 126.807 46.6523 127.09 46.666C127.394 46.6866 127.629 46.714 127.809
              46.762L125.735 50.4972L128.037 54.7875C127.836 54.8287 127.588 54.8561 127.283 54.8835C126.979 54.9109
              126.724 54.9109 126.496 54.9109C126.205 54.9109 125.915 54.904 125.632 54.8835C125.348 54.8629 125.134
              54.8355 124.968 54.7875L122.75 50.6068L124.713 46.762H124.72ZM119.668 46.762C119.917 46.714 120.151
              46.6729 120.38 46.6523C120.628 46.6318 120.856 46.6249 121.078 46.6249C121.299 46.6249 121.52 46.6386
              121.762 46.6523C122.01 46.6729 122.245 46.7072 122.474 46.762V54.7875C122.183 54.8355 121.928 54.8629
              121.686 54.8835C121.458 54.904 121.243 54.9109 121.071 54.9109C120.884 54.9109 120.677 54.904 120.435
              54.8835C120.207 54.8766 119.937 54.8424 119.654 54.7875V46.762H119.668ZM114.443 53.0536C114.547 53.0536
              114.692 53.0467 114.879 53.0262C115.065 53.0056 115.21 52.985 115.3 52.9645V51.2511H114.346C113.959
              51.2511 113.635 51.3265 113.365 51.4841C113.096 51.6417 112.971 51.8542 112.971 52.1352C112.971
              52.3408 113.02 52.5053 113.123 52.6355C113.227 52.752 113.344 52.8343 113.489 52.9028C113.648 52.9645
              113.807 53.0125 113.973 53.033C114.139 53.0399 114.305 53.0536 114.45 53.0536M110.511 52.1832C110.511
              51.676 110.628 51.2511 110.856 50.9221C111.084 50.5931 111.389 50.3258 111.762 50.1271C112.135 49.9283
              112.536 49.7981 112.985 49.7159C113.434 49.6268 113.863 49.5925 114.284 49.5925H115.3C115.293 49.4075
              115.238 49.2498 115.134 49.1265C115.031 48.9963 114.906 48.914 114.754 48.8455C114.595 48.7769 114.429
              48.7221 114.236 48.7015C114.049 48.6741 113.856 48.6604 113.648 48.6604C113.379 48.6604 113.068 48.6878
              112.715 48.7564C112.363 48.8044 111.997 48.8934 111.61 49.0237C111.506 48.8455 111.423 48.6878 111.34
              48.5371C111.278 48.3931 111.216 48.2424 111.174 48.0984C111.14 47.9408 111.119 47.79 111.084
              47.6324C111.071 47.4679 111.071 47.2829 111.071 47.0773C111.603 46.9128 112.135 46.7825 112.66
              46.7072C113.192 46.6181 113.669 46.5838 114.098 46.5838C114.678 46.5838 115.196 46.6455 115.666
              46.7825C116.136 46.9059 116.523 47.1047 116.848 47.3788C117.18 47.6529 117.442 47.9956 117.615
              48.4274C117.795 48.8455 117.885 49.3458 117.885 49.9215V54.486C117.456 54.6025 116.952 54.7121
              116.344 54.8287C115.742 54.9452 115.107 55 114.443 55C113.863 55 113.331 54.952 112.84 54.8424C112.363
              54.7464 111.955 54.5888 111.603 54.3763C111.257 54.157 110.988 53.8691 110.787 53.5196C110.601 53.1427
              110.504 52.6972 110.504 52.1832M98.2926 46.7894C97.7466 46.9059 97.2836 47.0224 96.8897
              47.1458V54.8012C97.1799 54.8492 97.4356 54.8903 97.6775 54.8972C97.9056 54.9177 98.1198 54.9246 98.3133
              54.9246C98.493 54.9246 98.6934 54.9177 98.9284 54.8972C99.1564 54.8903 99.4259 54.8561
              99.7162 54.8012V48.9757C99.7507 48.9551 99.8337 48.9346 99.9719 48.914C100.117 48.8935 100.255 48.8866
              100.38 48.8866C100.836 48.8866 101.161 49.01 101.347 49.243C101.534 49.476 101.63 49.8804 101.63
              50.4218V54.8012C101.921 54.8492 102.176 54.8903 102.418 54.8972C102.646 54.9177 102.868 54.9246 103.054
              54.9246C103.241 54.9246 103.434 54.9177 103.676 54.8972C103.904 54.8903 104.167 54.8561 104.457
              54.8012V50.2505C104.457 49.7844 104.409 49.3732 104.305 49.0031C104.36 48.9825 104.464 48.9551
              104.609 48.9277C104.761 48.9003 104.92 48.8866 105.072 48.8866C105.528 48.8866 105.86 49.01 106.06
              49.243C106.261 49.476 106.364 49.8804 106.364 50.4218V54.8012C106.655 54.8492 106.91 54.8903 107.152
              54.8972C107.38 54.9177 107.601 54.9246 107.788 54.9246C107.975 54.9246 108.168 54.9177 108.403
              54.8972C108.631 54.8903 108.901 54.8561 109.191 54.8012V50.1408C109.191 49.3663 109.067 48.7495
              108.825 48.2835C108.597 47.8174 108.286 47.461 107.906 47.2075C107.539 46.9539 107.118 46.7963
              106.655 46.7277C106.199 46.6386 105.749 46.5975 105.321 46.5975C104.83 46.5975 104.395 46.6455
              104.008 46.7551C103.621 46.8648 103.275 46.9744 102.992 47.1115C102.619 46.9059 102.204 46.7688
              101.755 46.7003C101.306 46.6318 100.856 46.5906 100.407 46.5906C99.5503 46.5838 98.8523 46.6455
              98.3133 46.7757M87.7328 54.7944C88.0231 54.8424 88.2719 54.8835 88.4999 54.8903C88.7211 54.9109 88.9284
              54.9177 89.1219 54.9177C89.3016 54.9177 89.502 54.9109 89.737 54.8903C89.965 54.8835 90.2346 54.8492
              90.5248 54.7944V48.6741C90.6354 48.6536 90.8012 48.6467 91.0086 48.6467C91.3818 48.6467 91.6582
              48.7358 91.824 48.914C92.0037 49.0785 92.0936 49.2978 92.0936 49.5651C92.0936 49.8324 92.0245 50.086
              91.8793 50.3327C91.7342 50.5589 91.4647 50.7782 91.0777 50.9838L90.8496 51.1072L92.6948 54.7875C92.8814
              54.8287 93.1233 54.8561 93.4066 54.8835C93.69 54.9109 94.001 54.9109 94.3119 54.9109C94.5746 54.9109
              94.8302 54.904 95.0998 54.8835C95.3831 54.8629 95.625 54.8355 95.853 54.7875L93.9526 51.395C94.0286
              51.3333 94.1323 51.2511 94.2497 51.1414C94.3741 51.0318 94.4847 50.9084 94.6022 50.7302C94.7197
              50.552 94.8095 50.3464 94.8855 50.1065C94.9616 49.8735 95.003 49.5857 95.003 49.2635C95.003 48.4137
              94.6644 47.7558 93.9871 47.2897C93.3237 46.81 92.3147 46.5769 90.9671 46.5769C90.4695 46.5769 89.9374
              46.5975 89.3638 46.6386C88.8109 46.6797 88.265 46.7346 87.7467 46.7963V54.8012L87.7328 54.7944ZM83.4343
              50.8193C83.4343 50.1545 83.3099 49.6473 83.068 49.291C82.84 48.9414 82.4737 48.7632 81.983
              48.7632C81.4924 48.7632 81.133 48.9414 80.898 49.291C80.6631 49.6405 80.5456 50.1477 80.5456
              50.8193C80.5456 51.491 80.6631 51.9776 80.898 52.3271C81.1261 52.6766 81.4924 52.8548 81.983
              52.8548C82.4737 52.8548 82.8331 52.6766 83.068 52.3271C83.3168 51.9776 83.4343 51.4773 83.4343
              50.8193ZM77.6914 50.8193C77.6914 50.1888 77.7813 49.6062 77.9609 49.0854C78.1475 48.5576 78.424
              48.1053 78.7764 47.7352C79.1427 47.3651 79.5919 47.0773 80.124 46.8785C80.6562 46.6729 81.2712
              46.5701 81.9692 46.5701C82.6672 46.5701 83.303 46.6729 83.8421 46.8785C84.3742 47.0773 84.8234
              47.3651 85.1758 47.7352C85.5421 48.1053 85.8185 48.5576 85.9913 49.0854C86.1779 49.5994 86.2747
              50.1819 86.2747 50.8193C86.2747 51.4567 86.1779 52.0118 85.9913 52.5327C85.8116 53.0399 85.5421
              53.4854 85.1758 53.8554C84.8234 54.2187 84.3742 54.4997 83.8421 54.6984C83.3099 54.8903 82.6879
              54.9931 81.9692 54.9931C81.2505 54.9931 80.6562 54.8903 80.124 54.6984C79.5919 54.4997 79.1427 54.2187
              78.7764 53.8554C78.424 53.4854 78.1475 53.0399 77.9609 52.5327C77.7813 52.0187 77.6914 51.443 77.6914
              50.8193ZM71.444 52.7726C71.4855 52.7726 71.5477 52.7794 71.6099 52.7863C71.6859 52.7931 71.7965 52.8
              71.9416 52.8C72.5636 52.8 73.0266 52.6424 73.3307 52.3202C73.6417 51.9913 73.8006 51.4498 73.8006
              50.7028C73.8006 50.038 73.6486 49.5582 73.3514 49.2567C73.0474 48.9483 72.6189 48.7906 72.066
              48.7906C71.9347 48.7906 71.8103 48.7975 71.6998 48.8044C71.5892 48.8112 71.5062 48.8249 71.444
              48.8318V52.7726ZM71.5823 46.5701C72.4876 46.5701 73.2478 46.6729 73.8836 46.8648C74.5263 47.0635
              75.0515 47.3445 75.4661 47.7078C75.8808 48.0573 76.178 48.4959 76.3715 49.0031C76.565 49.5103 76.6548
              50.0791 76.6548 50.7028C76.6548 51.3265 76.5511 51.9501 76.3507 52.4779C76.1641 53.0056 75.8601 53.4579
              75.4316 53.828C75.0169 54.1981 74.4779 54.4928 73.8145 54.6984C73.1579 54.8903 72.3632 54.9931 71.4302
              54.9931C70.8912 54.9931 70.4005 54.9726 69.9651 54.9315C69.5436 54.904 69.1013 54.8561 68.6313
              54.7875V46.7894C69.1013 46.7414 69.592 46.6866 70.1172 46.6523C70.6355 46.5975 71.1262 46.5769 71.5823
              46.5632" fill="white"/>
              <path d="M126.71 44.6922C126.71 44.6922 126.765 44.6922 126.8 44.6785C126.834 44.6647 126.862 44.6785
              126.889 44.6785C126.917 44.6785 126.945 44.6785 126.972 44.6785C127.007 44.6785 127.035 44.6785 127.062
              44.6922L127.352 45.3844L127.65 44.6922C127.65 44.6922 127.698 44.6922 127.726 44.6785C127.753 44.6647
              127.781 44.6785 127.809 44.6785C127.836 44.6785 127.864 44.6785 127.898 44.6785C127.933 44.6785 127.954
              44.6785 127.981 44.6922L128.044 46.0218C128.044 46.0218 128.002 46.0218 127.974 46.0355C127.947 46.0355
              127.912 46.0355 127.871 46.0355C127.829 46.0355 127.767 46.0355 127.705 46.0149L127.67 45.2404L127.456
              45.7476C127.456 45.7476 127.408 45.7476 127.387 45.7476C127.359 45.7476 127.346 45.7476 127.325
              45.7476C127.304 45.7476 127.283 45.7476 127.263 45.7476C127.242 45.7476 127.221 45.7476 127.2
              45.7339L127.007 45.2336L126.979 46.0012C126.924 46.0149 126.869 46.0218 126.82 46.0218C126.779 46.0218
              126.717 46.0218 126.661 46.0012L126.717 44.6785L126.71 44.6922ZM125.818 44.98H125.487C125.473 44.932
              125.466 44.8772 125.466 44.8361C125.466 44.795 125.466 44.747 125.487 44.6922H126.509C126.509 44.6922
              126.523 44.7401 126.523 44.7676C126.523 44.795 126.523 44.8087 126.523 44.8361C126.523 44.8772 126.523
              44.9252 126.502 44.98H126.171V46.0286C126.102 46.0423 126.046 46.0492 125.991 46.0492C125.936 46.0492
              125.88 46.0492 125.811 46.0286V44.98H125.818Z" fill="white"/>
            </svg>
          </a>
        </div>
        <div class="year">
          <p>© {{ currentYear }} Dormak -
            <span>Todos direitos reservados</span>
          </p>
        </div>
      </div>
      <div class="container-infos">
        <div class="footer1">
          <ul>
            <li v-for="item in footerData.footer_menu" :key="item.id">
              <a :href="item.link">
                {{ item.alternative || item.label }}
              </a>
            </li>
          </ul>
        </div>
        <div class="footer2">
          <ul>
            <li v-for="itemfooter2 in footerData.footer_menu_2">
              <a :href="itemfooter2.link">
                {{itemfooter2.alternative || itemfooter2.label}}
              </a>
            </li>
          </ul>
        </div>
        <div class="footer3">
          <div class="container-redes">
            <div class="facebook">
              <a :href="linkFacebook">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g clip-path="url(#clip0_115_309)">
                    <path d="M20 10.0613C20 4.50378 15.5225 -0.0012207 10 -0.0012207C4.475 2.9297e-05 -0.00250244
                    4.50378 -0.00250244 10.0625C-0.00250244 15.0838 3.655 19.2463 8.435
                    20.0013V12.97H5.8975V10.0625H8.4375V7.84378C8.4375 5.32253 9.93125 3.93003 12.215 3.93003C13.31
                    3.93003 14.4537 4.12628 14.4537 4.12628V6.60128H13.1925C11.9512 6.60128 11.5637 7.37753 11.5637
                    8.17378V10.0613H14.3362L13.8937 12.9688H11.5625V20C16.3425 19.245 20 15.0825 20 10.0613Z"
                          fill="white"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_115_309">
                      <rect width="20" height="20" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            <div class="instagram">
              <a :href="linkInstagram">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g clip-path="url(#clip0_115_311)">
                    <path d="M10 0C7.28625 0 6.945 0.0125 5.87875 0.06C4.8125 0.11 4.08625 0.2775 3.45 0.525C2.78231
                    0.775407 2.17768 1.16925 1.67875 1.67875C1.16925 2.17768 0.775407 2.78231 0.525 3.45C0.2775 4.085
                    0.10875 4.8125 0.06 5.875C0.0125 6.94375 0 7.28375 0 10.0013C0 12.7163 0.0125 13.0563 0.06
                    14.1225C0.11 15.1875 0.2775 15.9137 0.525 16.55C0.78125 17.2075 1.1225 17.765 1.67875
                    18.3212C2.23375 18.8775 2.79125 19.22 3.44875 19.475C4.08625 19.7225 4.81125 19.8912 5.87625
                    19.94C6.94375 19.9875 7.28375 20 10 20C12.7163 20 13.055 19.9875 14.1225 19.94C15.1863 19.89
                    15.915 19.7225 16.5513 19.475C17.2185 19.2244 17.8227 18.8306 18.3212 18.3212C18.8775 17.765
                    19.2188 17.2075 19.475 16.55C19.7213 15.9137 19.89 15.1875 19.94 14.1225C19.9875 13.0563 20
                    12.7163 20 10C20 7.28375 19.9875 6.94375 19.94 5.87625C19.89 4.8125 19.7213 4.085 19.475
                    3.45C19.2246 2.78231 18.8308 2.17768 18.3212 1.67875C17.8223 1.16925 17.2177 0.775407 16.55
                    0.525C15.9125 0.2775 15.185 0.10875 14.1213 0.06C13.0538 0.0125 12.715 0 9.9975 0H10ZM9.10375
                    1.8025H10.0013C12.6713 1.8025 12.9875 1.81125 14.0413 1.86C15.0162 1.90375 15.5462 2.0675
                    15.8988 2.20375C16.365 2.385 16.6987 2.6025 17.0487 2.9525C17.3988 3.3025 17.615 3.635 17.7963
                    4.1025C17.9338 4.45375 18.0963 4.98375 18.14 5.95875C18.1887 7.0125 18.1987 7.32875 18.1987
                    9.9975C18.1987 12.6663 18.1887 12.9837 18.14 14.0375C18.0963 15.0125 17.9325 15.5413 17.7963
                    15.8938C17.6348 16.3274 17.3791 16.7197 17.0475 17.0425C16.6975 17.3925 16.365 17.6088 15.8975
                    17.79C15.5475 17.9275 15.0175 18.09 14.0413 18.135C12.9875 18.1825 12.6713 18.1938 10.0013
                    18.1938C7.33125 18.1938 7.01375 18.1825 5.96 18.135C4.985 18.09 4.45625 17.9275 4.10375
                    17.79C3.66979 17.6291 3.277 17.3738 2.95375 17.0425C2.62159 16.7195 2.36541 16.3267 2.20375
                    15.8925C2.0675 15.5412 1.90375 15.0113 1.86 14.0363C1.8125 12.9825 1.8025 12.6663 1.8025
                    9.995C1.8025 7.32375 1.8125 7.01 1.86 5.95625C1.905 4.98125 2.0675 4.45125 2.205 4.09875C2.38625
                    3.6325 2.60375 3.29875 2.95375 2.94875C3.30375 2.59875 3.63625 2.3825 4.10375 2.20125C4.45625
                    2.06375 4.985 1.90125 5.96 1.85625C6.8825 1.81375 7.24 1.80125 9.10375 1.8V1.8025ZM15.3387
                    3.4625C15.1812 3.4625 15.0251 3.49354 14.8795 3.55384C14.7339 3.61415 14.6017 3.70254 14.4902
                    3.81397C14.3788 3.9254 14.2904 4.05769 14.2301 4.20328C14.1698 4.34887 14.1388 4.50491 14.1388
                    4.6625C14.1388 4.82009 14.1698 4.97613 14.2301 5.12172C14.2904 5.26731 14.3788 5.3996 14.4902
                    5.51103C14.6017 5.62246 14.7339 5.71085 14.8795 5.77116C15.0251 5.83146 15.1812 5.8625 15.3387
                    5.8625C15.657 5.8625 15.9622 5.73607 16.1873 5.51103C16.4123 5.28598 16.5387 4.98076 16.5387
                    4.6625C16.5387 4.34424 16.4123 4.03902 16.1873 3.81397C15.9622 3.58893 15.657 3.4625 15.3387
                    3.4625ZM10.0013 4.865C9.32009 4.85437 8.64362 4.97936 8.01122 5.23268C7.37883 5.486 6.80314
                    5.86259 6.31769 6.34053C5.83223 6.81847 5.4467 7.38821 5.18355 8.01657C4.9204 8.64494 4.78488
                    9.31938 4.78488 10.0006C4.78488 10.6819 4.9204 11.3563 5.18355 11.9847C5.4467 12.613 5.83223
                    13.1828 6.31769 13.6607C6.80314 14.1387 7.37883 14.5153 8.01122 14.7686C8.64362 15.0219 9.32009
                    15.1469 10.0013 15.1363C11.3494 15.1152 12.6353 14.5649 13.5812 13.6041C14.5272 12.6432 15.0574
                    11.349 15.0574 10.0006C15.0574 8.65228 14.5272 7.35802 13.5812 6.39719C12.6353 5.43636 11.3494
                    4.88603 10.0013 4.865ZM10.0013 6.66625C10.439 6.66625 10.8726 6.75248 11.277 6.92002C11.6815
                    7.08755 12.049 7.33312 12.3586 7.64268C12.6681 7.95225 12.9137 8.31976 13.0812 8.72423C13.2488
                    9.1287 13.335 9.56221 13.335 10C13.335 10.4378 13.2488 10.8713 13.0812 11.2758C12.9137 11.6802
                    12.6681 12.0477 12.3586 12.3573C12.049 12.6669 11.6815 12.9124 11.277 13.08C10.8726 13.2475 10.439
                    13.3337 10.0013 13.3337C9.11709 13.3337 8.26913 12.9825 7.64393 12.3573C7.01873 11.7321 6.6675
                    10.8842 6.6675 10C6.6675 9.11583 7.01873 8.26788 7.64393 7.64268C8.26913 7.01748 9.11709 6.66625
                    10.0013 6.66625Z" fill="white"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_115_311">
                      <rect width="20" height="20" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            <div class="whatsapp">
              <a href="">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g clip-path="url(#clip0_115_313)">
                    <path d="M17.0012 2.90757C16.0845 1.98194 14.9926 1.24813 13.7893 0.748936C12.586 0.249746
                    11.2953 -0.00482603 9.9925 6.92813e-05C4.53375 6.92813e-05 0.085 4.44757 0.08 9.90757C0.08
                    11.6563 0.5375 13.3576 1.40125 14.8638L0 20.0001L5.255 18.6226C6.70811 19.4154 8.33719 19.8302
                    9.9925 19.8288H9.9975C15.4575 19.8288 19.905 15.3813 19.91 9.91632C19.9111 8.61389 19.6546
                    7.32411 19.1551 6.12125C18.6557 4.91838 17.9245 3.82619 17.0012 2.90757ZM9.9925 18.1513C8.51647
                    18.1502 7.06778 17.753 5.7975 17.0013L5.4975 16.8213L2.38 17.6388L3.2125 14.5976L3.0175
                    14.2838C2.19226 12.9717 1.75581 11.4526 1.75875 9.90257C1.75875 5.37007 5.455 1.67257 9.9975
                    1.67257C11.0797 1.67063 12.1515 1.88291 13.1513 2.29718C14.151 2.71145 15.0589 3.31952 15.8225
                    4.08632C16.5886 4.85025 17.196 5.75825 17.6096 6.75798C18.0232 7.75771 18.2349 8.82941 18.2325
                    9.91132C18.2275 14.4601 14.5312 18.1513 9.9925 18.1513ZM14.5113 11.9838C14.265 11.8601 13.0487
                    11.2613 12.82 11.1763C12.5925 11.0951 12.4262 11.0526 12.2638 11.3001C12.0975 11.5463 11.6225
                    12.1076 11.48 12.2688C11.3375 12.4351 11.19 12.4538 10.9425 12.3313C10.6962 12.2063 9.8975
                    11.9463 8.9525 11.1001C8.215 10.4438 7.72125 9.63132 7.57375 9.38507C7.43125 9.13757 7.56
                    9.00507 7.68375 8.88132C7.7925 8.77132 7.93 8.59132 8.05375 8.44882C8.17875 8.30632 8.22
                    8.20132 8.30125 8.03632C8.3825 7.86882 8.34375 7.72632 8.2825 7.60257C8.22 7.47882 7.72625
                    6.25757 7.5175 5.76507C7.3175 5.27882 7.11375 5.34632 6.96125 5.34007C6.81875 5.33132 6.6525
                    5.33132 6.48625 5.33132C6.36072 5.33451 6.2372 5.36358 6.12342 5.41671C6.00963 5.46984 5.90804
                    5.54588 5.825 5.64007C5.5975 5.88757 4.96125 6.48632 4.96125 7.70757C4.96125 8.92882 5.84875
                    10.1026 5.97375 10.2688C6.09625 10.4351 7.71625 12.9338 10.2025 14.0088C10.79 14.2651 11.2525
                    14.4163 11.6138 14.5313C12.2075 14.7213 12.7437 14.6926 13.1712 14.6313C13.6462 14.5588 14.635
                    14.0313 14.8438 13.4526C15.0487 12.8726 15.0488 12.3776 14.9862 12.2738C14.925 12.1688 14.7587
                    12.1076 14.5113 11.9838Z" fill="white"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_115_313">
                      <rect width="20" height="20" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
          <div class="container-inco">
            <p>
              {{ devByText }}
              <a target="_blank" href="https://incograf.com/"> Incograf &reg; </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>

</style>
